import { useState } from 'react';
import { Calendar } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import EmptyTable from '@/components/table/components/EmptyTable.tsx';
import plannedTransactionsApi from '@/features/dashboard/plannedTransactions/api/plannedTransactionsApi.ts';
import { plannedTransactionsApiQueryKeys } from '@/features/dashboard/plannedTransactions/api/plannedTransactionsApi.queryKeys.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import InitiatePaymentModal from '@/features/dashboard/onlinePayments/components/InitiatePaymentModal.tsx';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const PlannedTransactionsTable = () => {
  const [initiatePaymentId, setInitiatePaymentId] = useState<string | null>(
    null,
  );

  const rowContextMenuItems: RowContextMenuItemParams<RowWithId>[] = [
    {
      label: 'Zainicjuj płatność online',
      action: (row) => setInitiatePaymentId(row.id),
    },
  ];

  return (
    <>
      <Table
        queryKey={plannedTransactionsApiQueryKeys.all()}
        fetchData={plannedTransactionsApi.getAll}
        fetchTableDef={plannedTransactionsApi.getTableDefinition}
        rowContextMenuItems={rowContextMenuItems}
        tagTargetType={TaggableType.TRANSACTION}
        emptyDataComponent={
          <EmptyTable
            title="Brak zaplanowanych wpłat"
            description="Aktualnie brak zaplanowanych wpłat. System utworzy je automatycznie dla nowo zapisanych uczestników."
            icon={<Calendar />}
          />
        }
      />

      {initiatePaymentId && (
        <InitiatePaymentModal
          plannedTransactionId={initiatePaymentId}
          onClose={() => setInitiatePaymentId(null)}
        />
      )}
    </>
  );
};

export default PlannedTransactionsTable;
